import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useLocation } from 'react-router-dom';
import '../css/SlideTransition.css';

const SlideTransition = ({ children }) => {
    const location = useLocation();

    return (
        <TransitionGroup className="transition-group">
            <CSSTransition
                key={location.pathname}
                classNames="slide"
                timeout={500}
            >
                <div className="route-wrapper">
                    {children}
                </div>
            </CSSTransition>
        </TransitionGroup>
    );
};

export default SlideTransition;
